module.exports.stickerMargin = 10;
